<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<b-form @submit="onSubmitForm">
							<b-alert :show="showAlertError" variant="danger">
								<ul>
									<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
								</ul>
							</b-alert>
							<b-form-group horizontal :class="{ 'has-error': $v.form.title.$error }" label="Название" label-for="title" class="is-required">
								<b-form-input id="title" maxlength="255" v-model.trim="form.title"></b-form-input>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.short_title.$error }" label="Короткое название" label-for="short_title" class="is-required">
								<b-form-input id="short_title" maxlength="255" v-model.trim="form.short_title"></b-form-input>
								<b-form-text>Короткое название используется для документов.</b-form-text>
							</b-form-group>

							<b-form-group horizontal label="Описание" label-for="description">
								<b-form-textarea id="description" :rows="3" v-model.trim="form.description"></b-form-textarea>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.start_at.$error }" label="Дата начала" label-for="start_at" class="is-required">
								<date-picker id="start_at" @dp-change="doSetSystemDate" v-model="form.start_at" :config="datePickerConfig"></date-picker>
							</b-form-group>

							<b-form-group horizontal label="Продолжительность" label-for="duration">
								<b-form-select v-model="form.duration" class="col-sm-3">
									<option v-for="(duration, key) in durationData" :key="key" :value="duration.value">{{ duration.text }}</option>
								</b-form-select>
								<b-form-text>Продолжительность дней.</b-form-text>
							</b-form-group>
						</b-form>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="onSubmitForm">Сохранить изменения</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import eventAPI from '@/api/modules/event/event'
export default {
	components: {
		datePicker
	},
	data () {
		return {
			showAlertError: false,
			form: {
				title: '',
				short_title: '',
				description: '',
				start_at: ''
			},
			systemDate: '',
			errors: {},
			datePickerConfig: {
				locale: 'ru',
				format: 'D MMMM, YYYY',
				useCurrent: true,
				date: ''
			},
			durationData: [
				{value: 1, text: 1},
				{value: 2, text: 2},
				{value: 3, text: 3},
				{value: 4, text: 4},
				{value: 5, text: 5},
				{value: 6, text: 6},
				{value: 7, text: 7},
				{value: 8, text: 8},
				{value: 9, text: 9},
				{value: 10, text: 10},
				{value: 11, text: 11},
				{value: 12, text: 12},
				{value: 13, text: 13},
				{value: 14, text: 14},
				{value: 15, text: 15},
				{value: 16, text: 16},
				{value: 17, text: 17},
				{value: 18, text: 18},
				{value: 19, text: 19},
				{value: 20, text: 20}
			]
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	validations: {
		form: {
			title: {
				required
			},
			short_title: {
				required
			},
			start_at: {
				required
			}
		}
	},
	created () {
		this.getEvent()
	},
	methods: {
		getEvent () {
			eventAPI.findOne(this.id).then((data) => {
				this.form = {
					title: data.product.title,
					short_title: data.product.short_title,
					description: data.product.description,
					start_at: moment(data.start_at).format('D MMMM, YYYY'),
					duration: data.duration
				}
				this.systemDate = data.start_at
			})
		},
		doSetSystemDate (e) {
			if (e.date !== false) this.systemDate = moment(e.date).format('YYYY-MM-DD')
		},
		onSubmitForm (e) {
			e.preventDefault()
			this.$v.$touch()
			if (this.$v.$invalid) return false

			const data = {
				title: this.form.title,
				short_title: this.form.short_title,
				description: this.form.description,
				start_at: this.systemDate,
				duration: this.form.duration
			}
			eventAPI.update(this.id, data).then((response) => {
				this.$notify({
					group: 'default',
					type: 'success',
					'title': 'Поздравляем!',
					text: 'Данные успешно обновлены.'
				})
			}, (response) => {
				const errors = response.data.errors
				for (let key in errors) {
					this.$notify({
						group: 'default',
						type: 'danger',
						text: errors[key][0]
					})
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/event/update/index.vue